import { IFormikValues } from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.reportProblem.types";

export const getInitialValues = (): IFormikValues => {
  return {
    [EField.Subject]: undefined,
    [EField.Description]: undefined,
    [EField.Location]: undefined,
    [EField.Attachments]: undefined,
  };
};
